// Lock toàn bộ format thời gian về múi giờ Việt Nam (Asia/Ho_Chi_Minh = UTC+7),
// không phụ thuộc TZ của trình duyệt người xem.

const VN_TZ = 'Asia/Ho_Chi_Minh';

const _time   = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, timeZone: VN_TZ });
const _date   = new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: '2-digit', year: '2-digit', timeZone: VN_TZ });
const _dateLong = new Intl.DateTimeFormat('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, timeZone: VN_TZ });

export const VN_TIMEZONE = VN_TZ;

// { time: 'HH:mm:ss', date: 'dd/MM/yy' }
export const fmtTs = (ts) => {
    if (!ts) return { time: '—', date: '' };
    try {
        const d = new Date(ts);
        return { time: _time.format(d), date: _date.format(d) };
    } catch { return { time: '—', date: '' }; }
};

// 'HH:mm:ss' (chỉ giờ phút giây)
export const fmtTime = (ts) => {
    if (!ts) return '—';
    try { return _time.format(new Date(ts)); } catch { return '—'; }
};

// 'dd/MM/yyyy HH:mm:ss' đầy đủ
export const fmtDateTime = (ts) => {
    if (!ts) return '—';
    try { return _dateLong.format(new Date(ts)); } catch { return '—'; }
};

// 'HH:mm:ss\ndd/MM' cho 2-line display
export const fmtTimeMultiline = (ts) => {
    if (!ts) return 'N/A';
    try {
        const d = new Date(ts);
        return _time.format(d) + '\n' + _date.format(d).slice(0, 5);  // strip year → dd/MM
    } catch { return 'N/A'; }
};
